module.exports = __webpack_public_path__ + "static/sendit.78c2ab49.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/learn/sendit.png
// module id = 1166
// module chunks = 127651196306611